import { RootState } from "store/store";

export const userProfileSelector = (state: RootState) => state.userProfile;
export const userProfileDataSelector = (state: RootState) => state.userProfile.data;
export const userProfileLoadingSelector = (state: RootState) => state.userProfile.loading;
export const userProfileErrorSelector = (state: RootState) => state.userProfile.error;

// Derived selectors
export const userFullNameSelector = (state: RootState) => {
  const userProfile = state.userProfile.data;
  if (!userProfile) return "";
  return `${userProfile.first_name || ""} ${userProfile.last_name || ""}`.trim();
};

export const userEmailSelector = (state: RootState) => {
  const userProfile = state.userProfile.data;
  if (!userProfile) return "";
  return userProfile.attributes?.find((attr) => attr.type === "email")?.value || "";
};

export const userFirstNameSelector = (state: RootState) => {
  const userProfile = state.userProfile.data;
  return userProfile?.first_name || "";
};

export const userLastNameSelector = (state: RootState) => {
  const userProfile = state.userProfile.data;
  return userProfile?.last_name || "";
};

export const userRolesSelector = (state: RootState) => {
  const userProfile = state.userProfile.data;
  return userProfile?.meta?.roles || [];
}; 